import Style from "../style/userWallet.module.scss"
import BackArrow from '../../../../assets/svg/BackArrow';
import QuizWallicon from '../../../../assets/svg/QuizWallicon';
import Coin from "../../../../assets/svg/Coin";
import PerfectButtonIconLeft from "../../../../assets/svg/PerfectButtonIconLeft";
import PerfectButtonIconRight from "../../../../assets/svg/PerfectButtonIconRight"
import TransactionBox from "../component/TransactionBox";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import authAxios from "../../../../config/authAxios";
import EarningChart from "../component/EarningChart";
import BottomBar from "../component/BottomBar";

const UserWallet = () => {
  const navigation = useNavigate()
  const [transactions, setTransactions] = useState([])
  const [data, setData] = useState([]);
  const [wallet, setWallet] = useState({});

  const FetchWallet = async () => {
    try {
      const response = await authAxios.get(`/users/api/wallet-summary`);
      setData(response?.data?.chartData);
      setWallet(response?.data?.walletSummary)
    } catch (error) {
      console.error(error);
    }
  }

  const fetchTransaction = async () => {
    try {
      const response = await authAxios.get(`/users/api/fetch-transaction/1/0/3`);
      setTransactions([...response?.data?.data])
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    FetchWallet();
    fetchTransaction();
  }, [])
  return (
    <>
      <div className={Style.box_container}>
        <div className={Style.wallet_container}>
          <div onClick={() => navigation(-1)}>
            <BackArrow />
          </div>
          <QuizWallicon width={143} height={31} />
        </div>

        <div className={Style.wallet_bottom_container}>
          <div className={Style.paddinLeft}>


            <p className={Style.wallet_text1}>Coins available in wallet</p>
            <div className={Style.box1}>
              <Coin width={25} height={25} />
              <p className={Style.wallet_text2}>{wallet?.redeemable + wallet?.nonRedeemable}</p>
            </div>
            {data?.length >= 7 && <>

              <p className={Style.wallet_text1}>Earnings</p>
              <EarningChart data={data} />
            </>}
            {/* <div className={Style.box2} onClick={() => navigation("/brandStore")}><PerfectButtonIconRight /><p>Redeem coins on store</p><PerfectButtonIconLeft /></div> */}
          </div>

          <div className={Style.box3}>
            <p className={Style.wallet_text11}>Transaction history</p>
            <div className={Style.box4} onClick={() => navigation("/transaction-history")}><p className={Style.wallet_text3}>View All</p>
            </div>
          </div>
          <div className={Style.paddinLeft} style={{
            ...(transactions?.length === 0 && {
              flex: 1,
              display: "flex",
              justifyContent: "center"
            })
          }}>
            {transactions?.length > 0 ? transactions.map((e, index) => ( <TransactionBox key={index} data={e} />)) : <div className={Style.noHistory}><h3>No Transactions Found</h3></div>}
          </div>

        </div>
        <BottomBar />
      </div>
    </>
  )
}

export default UserWallet;